import { Page } from "@/models/page-models/Page";

export const SalesContractView: Page = {
  "path": "view-sales-contract/:quotationId",
  "name": "Quotation ",
  "props": {
    "data": {
      "title": "Quotation ",
      "arabicTitle": "عرض أسعار",
      "printable": "fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),==,'Under Production')",
      "url": "view-sales-contract/:quotationId",
      "groups": [
        {
          "groupItems": [
            {
              "name": "11b",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "formData.status",
                  "label": "Status",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,qtStatus,{{fetchedData.quotation.data}})",
                  "printable": false
                },
                {
                  "type": "label",
                  "variable": "formData.createdAt",
                  "label": "Creation Date",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,dateFormat,{{formData.createdAt}},show-time)",
                  "printable": false
                },
                {
                  "type": "label",
                  "variable": "formData.updatedAt",
                  "label": "Last Updated",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,dateFormat,{{formData.updatedAt}},show-time)",
                  "printable": false
                },
                {
                  "type": "label",
                  "variable": "fetchedData.quotation.data.customer.assignedTo.displayName",
                  "label": "Salesman",
                  "printable": false
                }
              ]
            },
            {
              "name": "11b1",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "fetchedData.quotation.data.rejectionReason",
                  "label": "Rejection Reason",
                  "labelType": "formula",
                  "formula": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.quotation.data.rejectionReason}},'),==,'Other'),fn(CONCAT,{{fetchedData.quotation.data.rejectionReason}}, - ,{{fetchedData.quotation.data.otherRejectionReason}}),{{fetchedData.quotation.data.rejectionReason}})",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.quotation.data.status}},'),==,'QT Failed')",
                  "printable": false
                }
              ]
            },
            {
              "name": "1b",
              "pageItems": [
                {
                  "type": "custom_QuotationDetails",
                  "variable": "fetchedData.quotation.data",
                  "label": "Quotation Details",
                  "config": {
                    "customerDetailsVariable": "fetchedData.selectedCustomer"
                  }
                }
              ]
            },
            {
              "name": "2b",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Contract Items",
                  "class": "text-subtitle-2"
                }
              ]
            },
            {
              "name": "3b",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Contract Items",
                  "disabled": "TRUE",
                  "items": "fetchedData.quotation.data.items",
                  "headers": [
                    {
                      "value": "__key",
                      "text": "Sl. No",
                      "type": "formula",
                      "formula": "fn(CONCAT,fn(SUM,{{__item.__key}},1),/,fn(LENGTH,{{fetchedData.quotation.data.items}}))"
                    },
                    {
                      "value": "customerPo",
                      "text": "Cust. PO#",
                      "type": "custom-url",
                      "formula": "fn(CONDITIONAL,fn(NOT,{{fetchedData.quotation.data.customerPO}}),none,{{fetchedData.quotation.data.customerPO}})",
                      "customUrlFns": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "openPoProof",
                            "type": "fnRedirect",
                            "arg1Key": "redirectUrl",
                            "arg1Value": "{{formData.uploadedProof.url}}",
                            "arg2Key": "openNewTab",
                            "arg2Value": "TRUE"
                          },
                          "name": "openPoProof"
                        }
                      ]
                    },
                    {
                      "value": "__item.product._id",
                      "text": "Item ID",
                      "type": "url",
                      "url": "/products/{{__item.product._id}}"
                    },
                    {
                      "value": "__item.product",
                      "text": "Description",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                    },
                    {
                      "value": "__item.product.repeatType",
                      "text": "Repeat Type",
                      "type": "productRepeatType"
                    },
                    {
                      "value": "__item.product.unit.unit2",
                      "text": "Selling Unit",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,baseUnit,{{__item.product}})"
                    },
                    {
                      "value": "__item.productPrice.price",
                      "text": "Unit Price",
                      "formula": "fn(HELPER_FN,unitPriceFormat,{{__item.productPrice.price}})"
                    },
                    {
                      "value": "__item.product.minimumQuantity",
                      "text": "MOQ",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.product.minimumQuantity}},true)"
                    },
                    {
                      "value": "__item.totalQuantity",
                      "text": "Total Quantity",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.totalQuantity}},true)"
                    },
                    {
                      "value": "__item.totalFOC",
                      "text": "Total FOC",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.totalFOC}},true)",
                      "showIf": "fn(ARRAY_SUM,{{__item.totalFOC}},{{fetchedData.quotation.data.items}})"
                    },
                    {
                      "value": "__item.value",
                      "text": "Value",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,currency,fn(MULTIPLY,{{__item.productPrice.price}},{{__item.totalQuantity}}))"
                    },
                    {
                      "value": "__item.quantityLeft",
                      "text": "Balance",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.quantityLeft}},true)"
                    },
                    {
                      "value": "__item.productionQuantity",
                      "text": "Production",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.productionQuantity}},true)"
                    },
                    {
                      "value": "__item.remainingFOC",
                      "text": "FOC Balance",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.remainingFOC}},true)",
                      "showIf": "fn(ARRAY_SUM,{{__item.totalFOC}},{{fetchedData.quotation.data.items}})"
                    },
                    {
                      "value": "__item.readyStock",
                      "text": "Stock",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.readyStock}},true)"
                    }
                  ],
                  "tableType": "static",
                  "showActions": false,
                  "selectableUniqueId": "_id",
                  "groupActions": [
                    {
                      "label": "Create Calloff Request",
                      "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),==,'Under Production'),&&,fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,QA_MANAGER),||,fn(MATCH_ROLE,ACCOUNTING_COSTING))))",
                      "onClick": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "copyDeliveryRequestForm",
                            "type": "fnCopyData",
                            "arg1Key": "sourceFn",
                            "arg1Value": "getDefaultForm",
                            "arg2Key": "destinationKey",
                            "arg2Value": "fetchedData.deliveryRequestForm"
                          },
                          "name": "copyDeliveryRequestForm"
                        },
                        {
                          "executionOrder": 2,
                          "pageFunction": {
                            "name": "pushToDeliveryRequestItems",
                            "type": "fnPushToArray",
                            "arg1Key": "sourceFn",
                            "arg1Value": "getDeliveryRequestItem",
                            "arg2Key": "destinationVariable",
                            "arg2Value": "fetchedData.deliveryRequestForm.items"
                          },
                          "name": "pushToDeliveryRequestItems"
                        },
                        {
                          "executionOrder": 3,
                          "pageFunction": {
                            "name": "openDeliveryRequestPopup",
                            "type": "fnOpenPopup",
                            "arg1Key": "popupName",
                            "arg1Value": "Create Calloff Request"
                          },
                          "name": "openDeliveryRequestPopup"
                        }
                      ]
                    }
                  ],
                  "neverHideActionBar": true,
                  "footer": {
                    "value": "fn(HELPER_FN,currency,fn(KEYED_ARRAY_SUM,fn(MULTIPLY,{{__arrayItem.productPrice.price}},{{__arrayItem.totalQuantity}}),{{fetchedData.quotation.data.items}},product._id))",
                    "quantity": "Total Value"
                  },
                  "fontSize": "0.75rem"
                }
              ]
            },
            {
              "name": "4b",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Calloff Requests",
                  "class": "text-subtitle-2"
                }
              ]
            },
            {
              "name": "5b",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Calloff Requests",
                  "disabled": "TRUE",
                  "items": "fetchedData.quotation.data.callOffs",
                  "headers": [
                    {
                      "value": "__key",
                      "text": "Sl. No",
                      "type": "formula",
                      "formula": "fn(CONCAT,fn(SUM,{{__item.__key}},1),/,fn(LENGTH,{{fetchedData.quotation.data.callOffs}}))"
                    },
                    {
                      "value": "__item.callOff._id",
                      "text": "Calloff #"
                    },
                    {
                      "value": "__item.product._id",
                      "text": "Item ID",
                      "type": "url",
                      "url": "/products/{{__item.product._id}}"
                    },
                    {
                      "value": "__item.product",
                      "text": "Description",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                    },
                    {
                      "value": "__item.product.unit.unit2",
                      "text": "Selling Unit",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,baseUnit,{{__item.product}})"
                    },
                    {
                      "value": "__item.productPrice.price",
                      "text": "Unit Price",
                      "formula": "fn(HELPER_FN,unitPriceFormat,{{__item.productPrice.price}})"
                    },
                    {
                      "value": "__item.quantity",
                      "text": "Quantity",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.quantity}},true)"
                    },
                    {
                      "value": "__item.FOC",
                      "text": "FOC",
                      "showIf": "fn(ARRAY_SUM,{{__item.FOC}},{{fetchedData.quotation.data.callOffs}})"
                    },
                    {
                      "value": "__item.value",
                      "text": "Value",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,currency,fn(MULTIPLY,{{__item.productPrice.price}},{{__item.quantity}}))"
                    },
                    {
                      "value": "__item.callOff.targetDate",
                      "text": "Target Date",
                      "type": "custom-url",
                      "formula": "fn(HELPER_FN,dateFormat,{{__item.callOff.targetDate}})",
                      "customUrlFns": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "openCallOffProof",
                            "type": "fnRedirect",
                            "arg1Key": "redirectUrl",
                            "arg1Value": "{{__item.callOff.callOffProof.url}}",
                            "arg2Key": "openNewTab",
                            "arg2Value": "TRUE"
                          },
                          "name": "openCallOffProof"
                        }
                      ]
                    },
                    {
                      "value": "__item.callOff.status",
                      "text": "Status"
                    }
                  ],
                  "tableType": "static",
                  "selectableUniqueId": "callOff._id",
                  "singleSelect": true,
                  "neverHideActionBar": true,
                  "groupActions": [
                    {
                      "label": "Create Production Order",
                      "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),==,'Under Production'),&&,fn(MATCH_ROLE,Customer Service | Manager))",
                      "onClick": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "copyCallOffOrderForm",
                            "type": "fnCopyData",
                            "arg1Key": "sourceFn",
                            "arg1Value": "getDefaultForm",
                            "arg2Key": "destinationKey",
                            "arg2Value": "fetchedData.calloffOrderForm"
                          },
                          "name": "copyCallOffOrderForm"
                        },
                        {
                          "executionOrder": 2,
                          "pageFunction": {
                            "name": "pushToCallOffItems",
                            "type": "fnPushToArray",
                            "arg1Key": "sourceFn",
                            "arg1Value": "getProductionOrderItem",
                            "arg2Key": "destinationVariable",
                            "arg2Value": "fetchedData.calloffOrderForm.items"
                          },
                          "name": "pushToCallOffItems"
                        },
                        {
                          "executionOrder": 3,
                          "pageFunction": {
                            "name": "openCallOffPopup",
                            "type": "fnOpenPopup",
                            "arg1Key": "popupName",
                            "arg1Value": "Create Production Order"
                          },
                          "name": "openCallOffPopup"
                        }
                      ]
                    },
                    {
                      "label": "Add To Target",
                      "onClick": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "copySelectedCalloff",
                            "type": "fnCopyData",
                            "arg1Key": "sourceKey",
                            "arg1Value": "__item",
                            "arg2Key": "destinationKey",
                            "arg2Value": "fetchedData.selectedCalloff"
                          },
                          "name": "copySelectedCalloff"
                        },
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "copyDefaultTargetForm",
                            "type": "fnCopyData",
                            "arg1Key": "sourceFn",
                            "arg1Value": "getDefaultTargetForm",
                            "arg2Key": "destinationKey",
                            "arg2Value": "fetchedData.targetForm"
                          },
                          "name": "copyDefaultTargetForm"
                        },
                        {
                          "executionOrder": 2,
                          "pageFunction": {
                            "name": "openAddToTargetPopup",
                            "type": "fnOpenPopup",
                            "arg1Key": "popupName",
                            "arg1Value": "Add To Target"
                          },
                          "name": "openAddToTargetPopup"
                        }
                      ]
                    }
                  ],
                  "fontSize": "0.75rem"
                }
              ]
            },
            {
              "name": "6b",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Production Orders",
                  "class": "text-subtitle-2"
                }
              ]
            },
            {
              "name": "7b",
              "pageItems": [
                {
                  "type": "table",
                  "label": "CallOff Orders",
                  "disabled": "TRUE",
                  "items": "fetchedData.quotation.data.orders",
                  "headers": [
                    {
                      "value": "__key",
                      "text": "Sl. No",
                      "type": "formula",
                      "formula": "fn(CONCAT,fn(SUM,{{__item.__key}},1),/,fn(LENGTH,{{fetchedData.quotation.data.orders}}))"
                    },
                    {
                      "value": "__item.order._id",
                      "text": "Order #",
                      "type": "url",
                      "url": "/order/{{__item.order._id}}"
                    },
                    {
                      "value": "__item.product._id",
                      "text": "Item ID",
                      "type": "url",
                      "url": "/products/{{__item.product._id}}"
                    },
                    {
                      "value": "__item.product",
                      "text": "Description",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                    },
                    {
                      "value": "__item.product.unit.unit2",
                      "text": "Selling Unit",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,baseUnit,{{__item.product}})"
                    },
                    {
                      "value": "__item.productPrice.price",
                      "text": "Unit Price",
                      "formula": "fn(HELPER_FN,unitPriceFormat,{{__item.productPrice.price}})"
                    },
                    {
                      "value": "__item.order.quantity",
                      "text": "Quantity",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.order.quantity}},true)"
                    },
                    {
                      "value": "__item.FOC",
                      "text": "FOC",
                      "showIf": "fn(ARRAY_SUM,{{__item.FOC}},{{fetchedData.quotation.data.orders}})"
                    },
                    {
                      "value": "__item.value",
                      "text": "Value",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,currency,fn(MULTIPLY,{{__item.productPrice.price}},{{__item.order.quantity}}))"
                    },
                    {
                      "value": "__item.order.deliveryDate",
                      "text": "Production Date",
                      "type": "custom-url",
                      "formula": "fn(HELPER_FN,dateFormat,{{__item.order.deliveryDate}})",
                      "customUrlFns": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "openCallOffProof",
                            "type": "fnRedirect",
                            "arg1Key": "redirectUrl",
                            "arg1Value": "{{__item.order.callOffProof.url}}",
                            "arg2Key": "openNewTab",
                            "arg2Value": "TRUE"
                          },
                          "name": "openCallOffProof"
                        }
                      ]
                    },
                    {
                      "value": "__item.order.status",
                      "text": "Status"
                    }
                  ],
                  "tableType": "static",
                  "neverHideActionBar": true,
                  "fontSize": "0.75rem"
                }
              ]
            },
            {
              "name": "8b",
              "pageItems": [
                {
                  "type": "custom_QtTermsCondtions",
                  "variable": "fetchedData.quotation.data",
                  "label": "Terms & Conditions",
                  "config": {
                    "tradeTermsListVariable": "fetchedData.tradeTermsDetails.data.0.data",
                    "paymentTermsListVariable": "fetchedData.paymentTermOptions.data.0.data"
                  }
                }
              ]
            },
            {
              "name": "9b",
              "pageItems": [
                {
                  "type": "fileupload",
                  "variable": "formData.uploadedProof",
                  "label": "PO",
                  "disabled": "TRUE",
                  "showIf": "{{formData.uploadedProof}}",
                  "previewType": "standard"
                }
              ],
              "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),==,'QT Successful')"
            },
            {
              "name": "12b",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Update PO Details",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copySubmitOrderForm",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getSubmitOrderForm",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.submitOrderForm"
                      },
                      "name": "copySubmitOrderForm"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "createUpdateOrderArray",
                        "type": "fnCreateArray",
                        "arg1Key": "sourceVariable",
                        "arg1Value": "fetchedData.quotation.data.orders",
                        "arg2Key": "destinationVariable",
                        "arg2Value": "fetchedData.submitOrderForm.orders",
                        "arg3Key": "arrayTransformationFn",
                        "arg3Value": "getOrderIdAndProduct"
                      },
                      "name": "createUpdateOrderArray"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "copyUploadedProof",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "fetchedData.quotation.data.uploadedProof",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.submitOrderForm.uploadedProof"
                      },
                      "name": "copyUploadedProof"
                    },
                    {
                      "executionOrder": 3,
                      "pageFunction": {
                        "name": "openUpdatePoPopup",
                        "type": "fnOpenPopup",
                        "arg1Key": "popupName",
                        "arg1Value": "Update PO Details"
                      },
                      "name": "openUpdatePoPopup"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "secondary"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),==,'QT Successful'),&&,fn(LOGICAL,fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager)),||,fn(MATCH_ROLE,Sales | Account Executive)))"
            },
            {
              "name": "12b (1)",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Reject",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "openRejectionPopup"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(LENGTH,{{fetchedData.quotation.data.requests}}),==,0)",
                  "color": "error",
                  "printable": false
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),==,'QT Successful'),&&,fn(LOGICAL,fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager)),||,fn(MATCH_ROLE,Sales | Account Executive)))"
            },
            {
              "name": "13b",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Extend",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "openExtendContractPopup",
                        "type": "fnOpenPopup",
                        "arg1Key": "popupName",
                        "arg1Value": "Extend Sales Order"
                      },
                      "name": "openExtendContractPopup"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(LENGTH,{{fetchedData.quotation.data.requests}}),==,0)",
                  "color": "primary"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),==,'Contract Expired'),||,fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),==,'Under Production')),&&,fn(LOGICAL,fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager)),||,fn(MATCH_ROLE,Sales | Account Executive)))"
            },
            {
              "name": "14b",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Cancel",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "requestCancelSalesContract",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/sales-contract/{{__params.quotationId}}/request/cancel",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE"
                      },
                      "name": "requestCancelSalesContract"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(LENGTH,{{fetchedData.quotation.data.requests}}),==,0)",
                  "color": "error"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),==,'Contract Expired'),||,fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),==,'Under Production')),&&,fn(LOGICAL,fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager)),||,fn(MATCH_ROLE,Sales | Account Executive)))"
            }
          ],
          "type": "genericGroup",
          "showIf": "fn(NOT,fn(HELPER_FN,scEditFlag,{{formData.status}}))"
        },
        {
          "groupItems": [
            {
              "name": "1c",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Confirm",
                  "onClick": [
                    {
                      "executionOrder": 3,
                      "pageFunction": {
                        "name": "confirmSalesContract",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/quotation/{{__params.quotationId}}/confirm-sales-contract",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE",
                        "arg4Key": "requestMethod",
                        "arg4Value": "GET"
                      },
                      "name": "confirmSalesContract"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "secondary"
                }
              ],
              "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),==,'QT Successful')"
            },
            {
              "name": "2c",
              "pageItems": [
                {
                  "type": "button",
                  "label": "View Reject Request",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "openRejectRequestPopup",
                        "type": "fnOpenPopup",
                        "arg1Key": "popupName",
                        "arg1Value": "View Reject Quotation Request"
                      },
                      "name": "openRejectRequestPopup"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.quotation.data.requests.0.type}},'),==,'Reject')",
                  "color": "error"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LENGTH,{{fetchedData.quotation.data.requests}}),>,0)"
            },
            {
              "name": "3c",
              "pageItems": [
                {
                  "type": "button",
                  "label": "View Extend Request",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "openExtendRequestPopup",
                        "type": "fnOpenPopup",
                        "arg1Key": "popupName",
                        "arg1Value": "View Extend Sales Order Request"
                      },
                      "name": "openExtendRequestPopup"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.quotation.data.requests.0.type}},'),==,'Extend')",
                  "color": "secondary"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LENGTH,{{fetchedData.quotation.data.requests}}),>,0)"
            },
            {
              "name": "4c",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Confirm Cancel Request",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "approveCancel",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/sales-contract/request/cancel/{{fetchedData.quotation.data.requests.0._id}}/approve",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE",
                        "arg4Key": "requestMethod",
                        "arg4Value": "GET"
                      },
                      "name": "approveCancel"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.quotation.data.requests.0.type}},'),==,'Cancel')",
                  "color": "secondary"
                },
                {
                  "type": "button",
                  "label": "Reject Cancel Request",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "rejectCancel",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/sales-contract/request/cancel/{{fetchedData.quotation.data.requests.0._id}}/reject",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE",
                        "arg4Key": "requestMethod",
                        "arg4Value": "GET"
                      },
                      "name": "rejectCancel"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.quotation.data.requests.0.type}},'),==,'Cancel')",
                  "color": "error"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LENGTH,{{fetchedData.quotation.data.requests}}),>,0)"
            }
          ],
          "type": "genericGroup",
          "showIf": "fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager))"
        },
        {
          "type": "popupGroup",
          "label": "View Reject Quotation Request",
          "width": "600",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.quotation.data.requests.0.reason",
                  "label": "Reason for rejecting",
                  "disabled": "TRUE",
                  "items": "fetchedData.qtRejectionReasons.data.0.data",
                  "itemText": "en",
                  "itemValue": "en",
                  "printable": false,
                  "multiple": true
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.quotation.data.requests.0.otherReason",
                  "label": "Please elaborate",
                  "showIf": "fn(INCLUDE_ARRAY,{{fetchedData.quotation.data.requests.0.reason}},Other)",
                  "disabled": "TRUE"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Approve",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "approveReject",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/sales-contract/request/reject/{{fetchedData.quotation.data.requests.0._id}}/approve",
                    "arg2Key": "postData",
                    "arg2Value": "{}",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE",
                    "arg4Key": "requestMethod",
                    "arg4Value": "GET"
                  },
                  "name": "approveReject"
                }
              ]
            },
            {
              "label": "Reject",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "rejectReject",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/sales-contract/request/reject/{{fetchedData.quotation.data.requests.0._id}}/reject",
                    "arg2Key": "postData",
                    "arg2Value": "{}",
                    "arg3Key": "requestMethod",
                    "arg3Value": "GET",
                    "arg4Key": "refreshPage",
                    "arg4Value": "TRUE"
                  },
                  "name": "rejectReject"
                }
              ]
            }
          ]
        },
        {
          "type": "popupGroup",
          "label": "Reject Quotation",
          "width": "600",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.rejectionForm.rejectionReason",
                  "label": "Reason for rejecting",
                  "disabled": "FALSE",
                  "items": "fetchedData.qtRejectionReasons.data.0.data",
                  "itemText": "en",
                  "itemValue": "en",
                  "printable": false,
                  "multiple": true
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.rejectionForm.otherRejectionReason",
                  "label": "Please elaborate",
                  "showIf": "fn(INCLUDE_ARRAY,{{fetchedData.rejectionForm.rejectionReason}},Other)",
                  "disabled": "FALSE"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Confirm",
              "onClick": [
                {
                  "executionOrder": 1,
                  "name": "rejectQoutation",
                  "pageFunction": {
                    "name": "rejectQoutation",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/sales-contract/{{fetchedData.quotation.data._id}}/request/reject",
                    "arg2Key": "postData",
                    "arg2Value": "fetchedData.rejectionForm",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE"
                  }
                },
                {
                  "executionOrder": 2,
                  "name": "closeRejectionPopup",
                  "pageFunction": {
                    "name": "closeRejectionPopup",
                    "type": "fnClosePopup",
                    "arg1Key": "popupName",
                    "arg1Value": "Reject Quotation"
                  }
                }
              ]
            }
          ]
        },
        {
          "type": "popupGroup",
          "label": "Update PO Details",
          "popupItems": [
            {
              "name": "1 (1)",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Po Details",
                  "disabled": "FALSE",
                  "items": "fetchedData.quotation.data.items",
                  "headers": [
                    {
                      "value": "__item.product._id",
                      "text": "Item ID",
                      "type": "url",
                      "url": "/products/{{__item.product._id}}"
                    },
                    {
                      "value": "__item.product",
                      "text": "Description",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                    },
                    {
                      "value": "__item.product.unit.unit2",
                      "text": "Selling Unit",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,baseUnit,{{__item.product}})"
                    },
                    {
                      "value": "__item.productPrice.price",
                      "text": "Unit Price",
                      "formula": "fn(HELPER_FN,unitPriceFormat,{{__item.productPrice.price}})"
                    },
                    {
                      "value": "__item.totalQuantity",
                      "text": "Quantity"
                    },
                    {
                      "value": "__item.totalFOC",
                      "text": "FOC"
                    },
                    {
                      "value": "__item.value",
                      "text": "Value",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,currency,fn(MULTIPLY,{{__item.productPrice.price}},{{__item.totalQuantity}}))"
                    }
                  ],
                  "tableType": "static"
                }
              ]
            },
            {
              "name": "2 (1)",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.submitOrderForm.customerPO",
                  "label": "Customer PO#",
                  "disabled": "FALSE"
                },
                {
                  "type": "fileupload",
                  "variable": "fetchedData.submitOrderForm.uploadedProof",
                  "label": "PO",
                  "disabled": "FALSE",
                  "color": "primary",
                  "previewType": "no-preview"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Update",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "updatePo",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/quotation/{{__params.quotationId}}/update-orders",
                    "arg2Key": "postData",
                    "arg2Value": "fetchedData.submitOrderForm",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE",
                    "arg4Key": "requestMethod",
                    "arg4Value": "PUT"
                  },
                  "name": "updatePo",
                  "executeIf": "fn(LOGICAL,fn(CONCAT,',{{formData.status}},'),==,'QT Successful')"
                },
                {
                  "executionOrder": 2,
                  "pageFunction": {
                    "name": "closeUpdatePoPopup",
                    "type": "fnClosePopup",
                    "arg1Key": "popupName",
                    "arg1Value": "Update PO Details"
                  },
                  "name": "closeUpdatePoPopup"
                }
              ]
            }
          ]
        },
        {
          "type": "popupGroup",
          "label": "Create Calloff Request",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "table",
                  "variable": "fetchedData.deliveryRequestForm.items",
                  "label": "Delivery Request table",
                  "disabled": "FALSE",
                  "items": "fetchedData.quotation.data.items",
                  "headers": [
                    {
                      "value": "__item.product._id",
                      "text": "Item ID",
                      "type": "url",
                      "url": "/products/{{__item.product._id}}"
                    },
                    {
                      "value": "__item.product",
                      "text": "Description",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                    },
                    {
                      "value": "__item.targetDate",
                      "text": "Target Date",
                      "type": "date",
                      "dateConfig": {
                        "minDateFormula": "{{formData.dateRange.startDate}}",
                        "maxDateFormula": "{{formData.dateRange.endDate}}"
                      }
                    },
                    {
                      "value": "__item.product.unit.unit2",
                      "text": "Selling Unit",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,baseUnit,{{__item.product}})"
                    },
                    {
                      "value": "__item.productPrice.price",
                      "text": "Unit Price",
                      "formula": "fn(HELPER_FN,unitPriceFormat,{{__item.productPrice.price}})"
                    },
                    {
                      "value": "__item.quantity",
                      "text": "Quantity",
                      "type": "text"
                    },
                    {
                      "value": "__item.FOC",
                      "text": "FOC",
                      "type": "text",
                      "showIf": "fn(LOGICAL,{{__item.totalFOC}},>,0)"
                    },
                    {
                      "value": "__item.value",
                      "text": "Value",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,currency,fn(MULTIPLY,{{__item.productPrice.price}},{{__variable.quantity}}))"
                    },
                    {
                      "value": "__item.additionalCharges",
                      "text": "Additional Charges",
                      "type": "text"
                    },
                    {
                      "value": "__item.additionalChargesType",
                      "text": "Additional Charges Type",
                      "type": "text"
                    }
                  ],
                  "tableType": "dynamic",
                  "variableKey": "product",
                  "itemKey": "product._id",
                  "canDelete": false
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "fileupload",
                  "variable": "fetchedData.callOffProof",
                  "label": "Request Proof",
                  "disabled": "FALSE",
                  "color": "primary",
                  "previewType": "no-preview"
                },
                {
                  "type": "dropdown",
                  "variable": "fetchedData.deliveryLocation",
                  "label": "Delivery Location",
                  "disabled": "FALSE",
                  "items": "formData.deliveryLocations"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Create",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "createCallOffFormArray",
                    "type": "fnCreateArray",
                    "arg1Key": "sourceVariable",
                    "arg1Value": "fetchedData.deliveryRequestForm.items",
                    "arg2Key": "destinationVariable",
                    "arg2Value": "fetchedData.deliveryRequestForm.items",
                    "arg3Key": "arrayTransformationFn",
                    "arg3Value": "getResolvedDeliveryRequestFormObject"
                  },
                  "name": "createCallOffFormArray"
                },
                {
                  "executionOrder": 2,
                  "pageFunction": {
                    "name": "createDeliveryRequest",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/quotation/{{__params.quotationId}}/create-call-off-request",
                    "arg2Key": "postData",
                    "arg2Value": "fetchedData.deliveryRequestForm",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE",
                    "arg4Key": "fnsAfterSubmit",
                    "arg4Value": "closeDeliveryRequestPopup"
                  },
                  "name": "createDeliveryRequest"
                }
              ]
            }
          ],
          "itemVariable": "formData"
        },
        {
          "type": "popupGroup",
          "label": "Create Production Order",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "table",
                  "variable": "fetchedData.calloffOrderForm.items",
                  "label": "Create Production Order form",
                  "disabled": "FALSE",
                  "items": "fetchedData.quotation.data.items",
                  "headers": [
                    {
                      "value": "__item.product._id",
                      "text": "Item ID",
                      "type": "url",
                      "url": "/products/{{__item.product._id}}"
                    },
                    {
                      "value": "__item.product",
                      "text": "Description",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                    },
                    {
                      "value": "__item.deliveryDate",
                      "text": "Production Date",
                      "type": "date",
                      "dateConfig": {
                        "minDateFormula": "{{formData.dateRange.startDate}}",
                        "maxDateFormula": "{{formData.dateRange.endDate}}"
                      }
                    },
                    {
                      "value": "__item.product.unit.unit2",
                      "text": "Selling Unit",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,baseUnit,{{__item.product}})"
                    },
                    {
                      "value": "__item.productPrice.price",
                      "text": "Unit Price",
                      "formula": "fn(HELPER_FN,unitPriceFormat,{{__item.productPrice.price}})"
                    },
                    {
                      "value": "__item.quantity",
                      "text": "Quantity",
                      "type": "text"
                    },
                    {
                      "value": "__item.FOC",
                      "text": "FOC",
                      "type": "text",
                      "showIf": "{{fetchedData.calloffOrderForm.items.0.FOC}}"
                    },
                    {
                      "value": "__item.value",
                      "text": "Value",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,currency,fn(MULTIPLY,{{__item.productPrice.price}},{{__variable.quantity}}))"
                    }
                  ],
                  "tableType": "dynamic",
                  "variableKey": "product",
                  "itemKey": "product._id",
                  "canDelete": false
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "fileupload",
                  "variable": "fetchedData.callOffProof",
                  "label": "CallOff Proof",
                  "disabled": "FALSE",
                  "color": "primary",
                  "previewType": "no-preview"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Create",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "createCallOffFormArray",
                    "type": "fnCreateArray",
                    "arg1Key": "sourceVariable",
                    "arg1Value": "fetchedData.calloffOrderForm.items",
                    "arg2Key": "destinationVariable",
                    "arg2Value": "fetchedData.calloffOrderForm.items",
                    "arg3Key": "arrayTransformationFn",
                    "arg3Value": "getResolvedCallOffFormObject"
                  },
                  "name": "createCallOffFormArray"
                },
                {
                  "executionOrder": 2,
                  "pageFunction": {
                    "name": "createCalloff",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/quotation/{{__params.quotationId}}/create-production-order",
                    "arg2Key": "postData",
                    "arg2Value": "fetchedData.calloffOrderForm",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE",
                    "arg4Key": "fnsAfterSubmit",
                    "arg4Value": "closeCalloffPopup"
                  },
                  "name": "createCalloff"
                }
              ]
            }
          ],
          "itemVariable": "formData"
        },
        {
          "type": "popupGroup",
          "label": "Update Calloff",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "table",
                  "variable": "fetchedData.calloffOrderForm.orders",
                  "label": "Update Calloff",
                  "disabled": "FALSE",
                  "items": "fetchedData.quotation.data.orders",
                  "headers": [
                    {
                      "value": "__item.product",
                      "text": "Description",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                    },
                    {
                      "value": "__item.deliveryDate",
                      "text": "Production Date",
                      "type": "date",
                      "dateConfig": {
                        "minDateFormula": "{{formData.dateRange.startDate}}",
                        "maxDateFormula": "{{formData.dateRange.endDate}}"
                      }
                    },
                    {
                      "value": "__item.product.unit.unit2",
                      "text": "Selling Unit",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,baseUnit,{{__item.product}})"
                    },
                    {
                      "value": "__item.productPrice.price",
                      "text": "Unit Price",
                      "formula": "fn(HELPER_FN,unitPriceFormat,{{__item.productPrice.price}})"
                    },
                    {
                      "value": "__item.quantity",
                      "text": "Quantity"
                    },
                    {
                      "value": "__item.FOC",
                      "text": "FOC",
                      "showIf": "fn(ARRAY_SUM,{{__item.FOC}},{{fetchedData.quotation.data.orders}})"
                    },
                    {
                      "value": "__item.value",
                      "text": "Value",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,currency,fn(MULTIPLY,{{__item.productPrice.price}},{{__item.quantity}}))"
                    },
                    {
                      "value": "__item.additionalCharges",
                      "text": "Additional Charges",
                      "type": "text"
                    },
                    {
                      "value": "__item.additionalChargesType",
                      "text": "Additional Charges Type",
                      "type": "text"
                    }
                  ],
                  "tableType": "dynamic",
                  "variableKey": "id",
                  "itemKey": "order._id",
                  "canDelete": false,
                  "validationVariable": "customerPO"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "fileupload",
                  "variable": "fetchedData.calloffOrderForm.orders.0.callOffProof",
                  "label": "CallOff Proof",
                  "disabled": "FALSE",
                  "color": "primary",
                  "previewType": "no-preview"
                },
                {
                  "type": "dropdown",
                  "variable": "fetchedData.calloffOrderForm.orders.0.deliveryLocation",
                  "label": "Delivery Location",
                  "disabled": "FALSE",
                  "items": "formData.deliveryLocations"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Update",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "updateCalloff",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/quotation/{{__params.quotationId}}/update-sales-contract-orders",
                    "arg2Key": "postData",
                    "arg2Value": "fetchedData.calloffOrderForm",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE",
                    "arg4Key": "requestMethod",
                    "arg4Value": "PUT"
                  },
                  "name": "updateCallOff"
                },
                {
                  "executionOrder": 2,
                  "pageFunction": {
                    "name": "closeUpdateCallOffPopup",
                    "type": "fnClosePopup",
                    "arg1Key": "popupName",
                    "arg1Value": "Update Calloff"
                  },
                  "name": "closeUpdateCallOffPopup"
                }
              ]
            }
          ],
          "itemVariable": "formData"
        },
        {
          "type": "popupGroup",
          "label": "Extend Sales Order",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Old Sales Order End Date ",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,dateFormat,{{formData.dateRange.endDate}})"
                },
                {
                  "type": "datepicker",
                  "variable": "fetchedData.extendContract.proposedDate",
                  "label": "Proposed Sales Order End Date",
                  "disabled": "FALSE",
                  "minDateFormula": "{{formData.dateRange.endDate}}"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Submit",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "extendSalesContract",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/sales-contract/{{__params.quotationId}}/request/extend",
                    "arg2Key": "postData",
                    "arg2Value": "fetchedData.extendContract",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE",
                    "arg4Key": "fnsAfterSubmit",
                    "arg4Value": "closeExtendPopup"
                  },
                  "name": "extendSalesContract"
                }
              ]
            }
          ]
        },
        {
          "type": "popupGroup",
          "label": "View Extend Sales Order Request",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Old Sales Order Contract End Date ",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,dateFormat,{{formData.dateRange.endDate}})"
                },
                {
                  "type": "label",
                  "label": "New Proposed Sales Order End Date",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,dateFormat,{{fetchedData.quotation.data.requests.0.proposedDate}})"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Approve",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "approveExtend",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/sales-contract/request/extend/{{fetchedData.quotation.data.requests.0._id}}/approve",
                    "arg2Key": "postData",
                    "arg2Value": "{}",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE",
                    "arg4Key": "requestMethod",
                    "arg4Value": "GET"
                  },
                  "name": "approveExtend"
                }
              ]
            },
            {
              "label": "Reject",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "rejectExtend",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/sales-contract/request/extend/{{fetchedData.quotation.data.requests.0._id}}/reject",
                    "arg2Key": "postData",
                    "arg2Value": "{}",
                    "arg3Key": "requestMethod",
                    "arg3Value": "GET",
                    "arg4Key": "refreshPage",
                    "arg4Value": "TRUE"
                  },
                  "name": "rejectExtend"
                }
              ]
            }
          ]
        },
        {
          "type": "popupGroup",
          "label": "Add To Target",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.targetForm.quantity",
                  "label": "Target Quantity",
                  "disabled": "FALSE",
                  "unit": "{{fetchedData.selectedCalloff.product.packingMode.0.unit1}}"
                },
                {
                  "type": "datepicker",
                  "variable": "fetchedData.targetForm.month",
                  "label": "Month",
                  "disabled": "FALSE",
                  "minDateFormula": "{{MONTH_START}}",
                  "maxDateFormula": "{{MONTH_END}}",
                  "showWeekNumber": true
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Add To Target",
              "onClick": [
                {
                  "executionOrder": 1,
                  "pageFunction": {
                    "name": "addToTarget",
                    "type": "fnSubmit",
                    "arg1Key": "apiUrl",
                    "arg1Value": "/api/v1/callOff/{{fetchedData.selectedCalloff.callOff._id}}/add-to-target",
                    "arg2Key": "postData",
                    "arg2Value": "fetchedData.targetForm",
                    "arg3Key": "refreshPage",
                    "arg3Value": "TRUE"
                  },
                  "name": "addToTarget"
                },
                {
                  "executionOrder": 2,
                  "pageFunction": {
                    "name": "closeTargetPopup",
                    "type": "fnClosePopup",
                    "arg1Key": "popupName",
                    "arg1Value": "Add To Target"
                  },
                  "name": "closeTargetPopup"
                }
              ]
            }
          ],
          "width": "500"
        }
      ],
      "useMaxPageWidth": true,
      "pageComments": {
        "commentsVariable": "formData.comments",
        "newCommentVariable": "fetchedData.commentsForm.text",
        "addComentAction": [
          {
            "executionOrder": 1,
            "name": "copyDefaultModel",
            "pageFunction": {
              "name": "copyDefaultModel",
              "type": "fnCopyData",
              "arg1Key": "sourceFn",
              "arg1Value": "getDefaultModel",
              "arg2Key": "destinationKey",
              "arg2Value": "fetchedData.commentsForm"
            }
          },
          {
            "executionOrder": 2,
            "pageFunction": {
              "name": "addComment",
              "type": "fnSubmit",
              "arg1Key": "apiUrl",
              "arg1Value": "/api/v1/comment/quotation/{{__params.quotationId}}/add",
              "arg2Key": "postData",
              "arg2Value": "fetchedData.commentsForm",
              "arg3Key": "refreshPage",
              "arg3Value": "TRUE"
            },
            "name": "addComment"
          }
        ],
        "deleteCommentAction": [
          {
            "executionOrder": 1,
            "pageFunction": {
              "name": "copyCommentId",
              "type": "fnCopyData",
              "arg1Key": "sourceKey",
              "arg1Value": "__item._id",
              "arg2Key": "destinationKey",
              "arg2Value": "fetchedData.commentId"
            },
            "name": "copyCommentId"
          },
          {
            "executionOrder": 2,
            "pageFunction": {
              "name": "deleteComment",
              "type": "fnSubmit",
              "arg1Key": "apiUrl",
              "arg1Value": "/api/v1/comment/{{fetchedData.commentId}}/delete?model=quotation",
              "arg2Key": "postData",
              "arg2Value": "{}",
              "arg3Key": "requestMethod",
              "arg3Value": "DELETE",
              "arg4Key": "refreshPage",
              "arg4Value": "TRUE"
            },
            "name": "deleteComment"
          }
        ],
        "updateCommentAction": [
          {
            "executionOrder": 1,
            "pageFunction": {
              "name": "copyCommentId",
              "type": "fnCopyData",
              "arg1Key": "sourceKey",
              "arg1Value": "__item._id",
              "arg2Key": "destinationKey",
              "arg2Value": "fetchedData.commentId"
            },
            "name": "copyCommentId"
          },
          {
            "executionOrder": 2,
            "pageFunction": {
              "name": "copyEditCommentTextForm",
              "type": "fnCopyData",
              "arg1Key": "sourceKey",
              "arg1Value": "__item",
              "arg2Key": "sourceFn",
              "arg2Value": "getEditCommentTextForm",
              "arg3Key": "destinationKey",
              "arg3Value": "fetchedData.editedCommentForm"
            },
            "name": "copyEditCommentTextForm"
          },
          {
            "executionOrder": 3,
            "pageFunction": {
              "name": "updateComment",
              "type": "fnSubmit",
              "arg1Key": "apiUrl",
              "arg1Value": "/api/v1/comment/{{fetchedData.commentId}}/edit",
              "arg2Key": "postData",
              "arg2Value": "fetchedData.editedCommentForm",
              "arg3Key": "requestMethod",
              "arg3Value": "PATCH",
              "arg4Key": "refreshPage",
              "arg4Value": "TRUE"
            },
            "name": "updateComment"
          }
        ]
      },
      "printDocDate": "{{formData.createdAt}}"
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getQuotationDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/quotation/get?id={{__params.quotationId}}&getLatest=true",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.quotation",
          "arg3Key": "fnsAfterSubmit",
          "arg3Value": "[{\"name\":\"copyCustomerDetails\",\"executionOrder\":1},{\"name\":\"copyQuotationData\",\"executionOrder\":1}]"
        },
        "name": "getQuotationDetails"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "redirectToQuotationView",
          "type": "fnRedirect",
          "arg1Key": "redirectUrl",
          "arg1Value": "/quotation/{{__params.quotationId}}",
          "arg2Key": "replace",
          "arg2Value": "TRUE"
        },
        "name": "redirectToQuotationView",
        "executeIf": "fn(LOGICAL,fn(CONCAT,',{{formData.type}},'),==,'Single')"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "redirectToScEdit",
          "type": "fnRedirect",
          "arg1Key": "redirectUrl",
          "arg1Value": "/edit-sales-contract/{{fetchedData.quotation.data._id}}",
          "arg2Key": "replace",
          "arg2Value": "TRUE"
        },
        "name": "redirectToScEdit",
        "executeIf": "fn(HELPER_FN,scEditFlag,{{formData.status}})"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getTradeTermDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=trade-terms",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.tradeTermsDetails"
        },
        "name": "getTradeTermDetails"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getPaymentTerms",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=payment-terms",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.paymentTermOptions"
        },
        "name": "getPaymentTerms"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "getRejectionReasons",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=quotation-rejection-reasons",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.qtRejectionReasons"
        },
        "name": "getRejectionReasons"
      }
    ],
    "functions": [
      {
        "name": "copyCustomerDetails",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getCustomerDetails",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData",
        "arg3Key": "destinationKeyType",
        "arg3Value": "Object",
        "arg4Key": "append",
        "arg4Value": "TRUE"
      },
      {
        "name": "getCustomerDetails",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "selectedCustomer": "fetchedData.quotation.data.customer"
        }
      },
      {
        "name": "copyQuotationData",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getQuotationData",
        "arg2Key": "destinationKey",
        "arg2Value": "formData"
      },
      {
        "name": "getQuotationData",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "type": "fetchedData.quotation.data.type",
          "parent": "fetchedData.quotation.data._id",
          "updatedAt": "fetchedData.quotation.data.updatedAt",
          "createdAt": "fetchedData.quotation.data.createdAt",
          "customer": "fetchedData.quotation.data.customer._id",
          "createdBy": "fetchedData.quotation.data.createdBy",
          "status": "fetchedData.quotation.data.status",
          "dateCreated": "fetchedData.quotation.data.dateCreated",
          "comments": "fetchedData.quotation.data.comments",
          "updates": "fetchedData.quotation.data.updates",
          "isLatest": "fetchedData.quotation.data.isLatest",
          "version": "fetchedData.quotation.data.version",
          "contact": "fetchedData.quotation.data.contact",
          "items": "fetchedData.quotation.data.items",
          "dateRange": "fetchedData.quotation.data.dateRange",
          "deliveryLocations": "fetchedData.quotation.data.deliveryLocations",
          "uploadedProof": "fetchedData.quotation.data.uploadedProof",
          "customerPO": "fetchedData.quotation.data.customerPO",
          "termsAndConditions": "fetchedData.quotation.data.termsAndConditions",
          "info": "fetchedData.quotation.data.info"
        }
      },
      {
        "name": "openRejectionPopup",
        "type": "fnOpenPopup",
        "arg1Key": "popupName",
        "arg1Value": "Reject Quotation"
      },
      {
        "name": "getSubmitOrderForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "orders": "[]"
        },
        "useFormula": true
      },
      {
        "name": "getOrderIdAndProduct",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "id": "fn(NUMBER,{{__selectedObject.order._id}})",
          "product": "fn(NUMBER,{{__selectedObject.product._id}})",
          "deliveryDate": "{{__selectedObject.order.deliveryDate}}"
        },
        "useFormula": true
      },
      {
        "name": "getDefaultForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "items": "[]"
        },
        "useFormula": true
      },
      {
        "name": "getProductionOrderItem",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "callOff": "{{__selectedObject.callOff._id}}",
          "product": "fn(NUMBER,{{__selectedObject.product._id}})",
          "quantity": "fn(NUMBER,{{__selectedObject.quantity}})",
          "FOC": "fn(NUMBER,{{__selectedObject.FOC}})",
          "deliveryDate": "fn(HELPER_FN,dateFormat,fn(ADD_DAYS,TODAYS_DATE,{{__variable.termsAndConditions.deliveryLeadTime}}),date-picker)"
        },
        "useFormula": true,
        "additionalVariable": "fetchedData.quotation.data"
      },
      {
        "name": "getDeliveryRequestItem",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "product": "fn(NUMBER,{{__selectedObject.product._id}})",
          "quantity": "fn(NUMBER,{{__selectedObject.quantityLeft}})",
          "FOC": "fn(NUMBER,{{__selectedObject.remainingFOC}})",
          "targetDate": "fn(HELPER_FN,dateFormat,fn(ADD_DAYS,TODAYS_DATE,{{__variable.termsAndConditions.deliveryLeadTime}}),date-picker)"
        },
        "useFormula": true,
        "additionalVariable": "fetchedData.quotation.data"
      },
      {
        "name": "getOrderDetails",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "id": "fn(NUMBER,{{__selectedObject.order._id}})",
          "product": "fn(NUMBER,{{__selectedObject.product._id}})",
          "deliveryDate": "{{__selectedObject.order.deliveryDate}}",
          "callOffProof": "{{__selectedObject.order.callOffProof}}",
          "deliveryLocation": "{{__selectedObject.order.deliveryLocation}}",
          "additionalCharges": "{{__selectedObject.order.additionalCharges}}",
          "additionalChargesType": "{{__selectedObject.order.additionalChargesType}}"
        },
        "useFormula": true
      },
      {
        "name": "closeCalloffPopup",
        "type": "fnClosePopup",
        "arg1Key": "popupName",
        "arg1Value": "Create Production Order"
      },
      {
        "name": "closeDeliveryRequestPopup",
        "type": "fnClosePopup",
        "arg1Key": "popupName",
        "arg1Value": "Create Calloff Request"
      },
      {
        "name": "getResolvedCallOffFormObject",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "callOff": "{{__selectedObject.callOff}}",
          "product": "{{__selectedObject.product}}",
          "quantity": "{{__selectedObject.quantity}}",
          "FOC": "{{__selectedObject.FOC}}",
          "deliveryDate": "{{__selectedObject.deliveryDate}}",
          "callOffProof": "{{fetchedData.callOffProof}}"
        },
        "useFormula": true
      },
      {
        "name": "getResolvedDeliveryRequestFormObject",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "product": "{{__selectedObject.product}}",
          "quantity": "{{__selectedObject.quantity}}",
          "FOC": "{{__selectedObject.FOC}}",
          "targetDate": "{{__selectedObject.targetDate}}",
          "additionalCharges": "{{__selectedObject.additionalCharges}}",
          "additionalChargesType": "{{__selectedObject.additionalChargesType}}",
          "deliveryLocation": "{{fetchedData.deliveryLocation}}",
          "callOffProof": "{{fetchedData.callOffProof}}"
        },
        "useFormula": true
      },
      {
        "name": "closeExtendPopup",
        "type": "fnClosePopup",
        "arg1Key": "popupName",
        "arg1Value": "Extend Sales Order"
      },
      {
        "name": "getEditCommentTextForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "text": "__item.text",
          "model": "__item.targetModel"
        }
      },
      {
        "name": "getDefaultModel",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "model": "quotation",
          "text": "{{fetchedData.commentsForm.text}}"
        },
        "useFormula": true
      },
      { 
        "name": "getDefaultTargetForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "quantity": "fn(HELPER_FN,convertSellingUnitQuantity,{{fetchedData.selectedCalloff.quantity}},{{fetchedData.selectedCalloff.product}},{{fetchedData.selectedCalloff.product.packingMode.0.unit1}})",
          "month": "fn(HELPER_FN,dateFormat,{{MONTH_END}},date-picker)"
        },
        "useFormula": true
      }
    ]
  },
  "forRole": "SALES_MANAGER,SALES_ACCOUNT_EXECUTIVE,CUSTOMER_SERVICE_MANAGER,ACCOUNTING_COSTING,GENERAL_MANAGER,QA_MANAGER",
  "visible": false
}